import React,{useContext,useEffect} from 'react'
import {HeadTableLeads, RowLeadsNoBranch} from "../../ui-components";
import LeadsContext from '../../context/leads';


function NoBranch({onToggleTab,setAssignLead, order }) {
  const {Leadslist, models, Subs} = useContext(LeadsContext)

  useEffect(()=>{
    Leadslist(7, order);
    Subs();
  },[order])

  const HeadTitle = {
    "Tel\u00E9fono": { display: "block" },
    Descarte: { display: "none" },
    "Qui\u00E9n descarta": { children: "C.P." },
    "Motivo de Descarte": { children: "Colonia" },
     "Asesor Conekta": { children: "Municipio" },
    Detalles: { display: "block", children: "Acción" },

  }

  return (
    <div className="overflow-x-scroll py-2">
    <HeadTableLeads type="discarded" width={"1955px"} overrides={HeadTitle}/>
    {models?.map((lead, index) => (
      index % 2 == 0 ?
      <RowLeadsNoBranch key={lead.id} leads={lead}overrides={{
        "cp":{children:lead?.adress?.cp},
        "municipio":{children:lead?.adress?.municipio},
        "colonia":{children:lead?.adress?.asentamiento},
        Button:{
          onClick: () =>{
            onToggleTab(7)
            setAssignLead(lead)
          }
        }
  
      }}/> :
      <RowLeadsNoBranch key={lead.id} leads={lead} overrides={{
        "Frame 20797":{backgroundColor: "#ffffff"},
        "cp":{children:lead?.adress?.cp},
        "municipio":{children:lead?.adress?.municipio},
        "colonia":{children:lead?.adress?.asentamiento},
        Button:{
          onClick: () =>{
            onToggleTab(7)
            setAssignLead(lead)
          }
        }
  
      }}/> 
    ))}
  </div>

  )
}

export default NoBranch